import { injectable } from "tsyringe";

// pages
import {
    to24h,
    isValidMeridiem,
    isValidHour,
    isValidMinute,
} from "@/pages/student-setting/ui/popup/setting-class/services/utils";

@injectable()
export class StringDateOrDateConverter {
    public convertToStringDate = () => {};

    public convertToDate = (stringDate: string): { hour: number; minute: number } | null => {
        const splitedStringDate = stringDate.split(" ");

        if (splitedStringDate.length !== 2) return null;

        const [time, modifier] = splitedStringDate;

        const splitedTime = time.split(":");

        // 시간과 분으로 나뉘어지지 않는다면
        if (splitedTime.length !== 2) return null;

        const [hour, minute] = splitedTime;

        const intHour = parseInt(hour, 10);
        const intMinute = parseInt(minute, 10);

        // 잘못된 기입이라면
        if (isNaN(intHour) || isNaN(intMinute)) return null;

        // 만일 시간이나 분이 비어있다면 null 을 반환합니다.
        if (hour === "" || minute === "") return null;
        // 올바른 modifier 및 시간, 분이 아니면 null 을 return 합니다.
        if (!isValidMeridiem(modifier) || !isValidHour(intHour) || !isValidMinute(intMinute))
            return null;

        // PM, AM 을 고려한 hour 값을 반환합니다.
        const modifiredHour = to24h(intHour, modifier);

        return {
            hour: modifiredHour,
            minute: parseInt(minute, 10),
        };
    };
}
